export { SimpleProductList } from './SimpleProductList';
